import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e.response?.status === 401) {
      localStorage.removeItem("token");
      if (!window.location.pathname.includes("/login")) window.location.href = "/login";
    }
    return Promise.reject(e);
  }
);

export function apiErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Terjadi kesalahan";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export const ROLE_LABELS = {
  SUPER_ADMIN: "Super Admin",
  DIREKTUR: "Direktur",
  MANAGER_OPERASIONAL: "Manager Operasional",
  PIMPINAN_PROYEK: "Pimpinan Proyek",
  STAFF_OPERASIONAL: "Staff Operasional",
};

export const RISK = {
  GREEN: { label: "On Track", cls: "bg-emerald-500/15 text-emerald-600 border-emerald-500/30", dot: "bg-emerald-500" },
  YELLOW: { label: "At Risk", cls: "bg-amber-500/15 text-amber-600 border-amber-500/30", dot: "bg-amber-500" },
  ORANGE: { label: "High Risk", cls: "bg-orange-500/15 text-orange-600 border-orange-500/30", dot: "bg-orange-500" },
  RED: { label: "Delayed", cls: "bg-red-500/15 text-red-600 border-red-500/30", dot: "bg-red-500" },
};

export const STATUS_LABELS = {
  DRAFT: "Draft", ACTIVE: "Aktif", PROCESSING: "Diproses",
  VERIFICATION: "Verifikasi", COMPLETED: "Selesai", ARCHIVED: "Diarsipkan",
};

export const CONF = {
  HIGH: "bg-emerald-500/15 text-emerald-600 border-emerald-500/30",
  MEDIUM: "bg-amber-500/15 text-amber-600 border-amber-500/30",
  LOW: "bg-red-500/15 text-red-600 border-red-500/30",
};

export const STATE = {
  WAITING: { label: "Menunggu", cls: "bg-slate-500/15 text-slate-600 border-slate-500/30" },
  CLAIMED: { label: "Diklaim", cls: "bg-blue-500/15 text-blue-600 border-blue-500/30" },
  IN_REVIEW: { label: "Sedang Direview", cls: "bg-blue-500/15 text-blue-600 border-blue-500/30" },
  APPROVED: { label: "Disetujui", cls: "bg-emerald-500/15 text-emerald-600 border-emerald-500/30" },
  REJECTED: { label: "Ditolak", cls: "bg-red-500/15 text-red-600 border-red-500/30" },
  RELEASED: { label: "Dilepas", cls: "bg-slate-500/15 text-slate-600 border-slate-500/30" },
  EXPIRED: { label: "Kedaluwarsa", cls: "bg-amber-500/15 text-amber-600 border-amber-500/30" },
};

export const REGISTER_FIELDS = [
  ["nomor_berkas", "Nomor Berkas"], ["kode_klasifikasi", "Kode Klasifikasi"],
  ["nomor_boks", "Nomor Boks"], ["nomor_rak", "Nomor Rak"], ["nomor_baris", "Nomor Baris"],
  ["nama_ruangan", "Nama Ruangan"], ["uraian_informasi", "Uraian Informasi Arsip"],
  ["jumlah", "Jumlah"],
  ["tingkat_perkembangan", "Tingkat Perkembangan"], ["kondisi_arsip", "Kondisi Arsip"],
  ["tahun_cipta", "Tahun Cipta"], ["retensi_aktif", "Retensi Aktif"],
  ["retensi_inaktif", "Retensi Inaktif"], ["nasib_akhir", "Nasib Akhir"],
  ["tingkat_keamanan", "Tingkat Keamanan"],
  ["hak_akses_internal", "Hak Akses Internal"], ["hak_akses_eksternal", "Hak Akses Eksternal"],
  ["keterangan", "Keterangan"],
];

export const DOC_TYPE_LABELS = {
  SPK: "SPK / Surat Perjanjian Kontrak", SURAT_MASUK: "Surat Masuk", SURAT_KELUAR: "Surat Keluar",
  SP2D: "SP2D", SPM: "SPM", DOKUMEN_LAINNYA: "Dokumen Lainnya", OTHER: "Dokumen Lainnya",
};
